<mat-toolbar class="mkt-navbar colorful-mat-toolbar">
  <span class="example-spacer"></span>
  <div class="mkt-navbar-options" fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="end center">
    <button class="nav-button" tourAnchor="matchmaking.find-your-meetings" mat-button routerLink="/Matchmaking/Meetings" routerLinkActive="active-route">
      <mat-icon>mark_chat_read</mat-icon>
      {{ 'matchmaking.navbar.meetings' | translate }}
    </button>
  </div>
</mat-toolbar>
